import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.169 6.76a10 10 0 0 1 10.899 2.172l2.538 2.53h-3.581a1 1 0 1 0 0 2h6a1 1 0 0 0 1-1.013V6.463a1 1 0 1 0-2 0v3.59l-2.543-2.535a12 12 0 1 0 0 16.964 1 1 0 1 0-1.414-1.414 10.001 10.001 0 1 1-10.9-16.308"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconArrowClockwise = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconArrowClockwise);
export default Memo;
